module.exports = __webpack_public_path__ + "img/light-yellow.22a17c6e.jpg";